import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95ae2bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "field lg:col-2 md:col-2" }
const _hoisted_3 = { class: "day h-full flex align-items-center lg:justify-content-center" }
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "field lg:col-4 md:col-12 sm:col-12" }
const _hoisted_9 = { class: "h-full flex align-items-center justify-content-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2 col-4 ml-2" }, "から", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = { class: "field lg:col-4 md:col-12 sm:col-12" }
const _hoisted_15 = { class: "h-full flex align-items-center justify-content-start" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2 col-4 ml-2" }, "から", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, ":", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "h-full flex lg:justify-content-start pt-1" }
const _hoisted_21 = ["for"]

import { reactive, watch, withDefaults, ref, computed } from "vue";
import { get, MaybeRefOrGetter, set } from "@vueuse/core";
import { dayOfWeek, data as dates } from "@/clinic/typings/enums/day-of-week";
import { range } from "lodash";
import { Rule, Rules, ValidateError } from "async-validator";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useToast } from "primevue/usetoast";
import commonTimeWorkRules from "@/clinic/validates/validate.time-work";

/**
 * フォームの型定義
 * @typedef {Object} IForm
 * @property {string} name - 日付フィールドの識別子
 * @property {boolean} [isSpecified] - 指定フラグ
 * @property {*} data - 初期データオブジェクト
 */
type IForm = {
  name: string;
  isSpecified?: boolean;
  data: any;
};

/**
 * propsの定義
 * @type {IForm}
 */
type IFormRuleValidation = {
  startTimeMorning: number;
  endTimeMorning: number;
  startTimeAfterNoon: number;
  endTimeAfterNoon: number;
};

/**
 * フィールドエラー格納用型定義
 * @typedef {Object.<string, string>} IFieldValidator
 */
type IFieldValidator = {
  [key: string]: string;
};

/**
 * 指定された値とルールでAsyncValidatorを初期化する
 *
 * @function
 * @param {any} value - 検証対象オブジェクト
 * @param {Record<string, Rule|Rules>} rules - バリデーションルールセット
 * @returns {ReturnType<typeof useAsyncValidator>} 初期化された AsyncValidator
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'date',
  props: {
    name: null,
    isSpecified: { type: Boolean, default: false },
    data: null
  },
  emits: ["updateDate", "validateFn"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { name: string, isSpecified: boolean, data: any };

/**
 * スタッフシフト入力フォーム用コンポーネント
 * 指定した曜日の午前・午後の稼働時間選択と休業日設定を行う
 *
 * @component
 */


/**
 * コンポーネントが発火するイベント定義
 * @event updateDate - 日付データ更新時
 * @event validateFn - バリデーション結果通知時
 */


const toast = useToast();

/** 午前の開始分 */
const morningStartMinute = ref({ name: "0分", value: "0" });
/** 午前の終了分 */
const morningEndMinute = ref({ name: "0分", value: "0" });
/** 午後の開始分 */
const afternoonStartMinute = ref({ name: "0分", value: "0" });
/** 午後の終了分 */
const afternoonEndMinute = ref({ name: "0分", value: "0" });

/**
 * 初期フォームデータをcomputedで生成
 *
 * props.data の以下のキーから
 * - `${name}_morning_start`, `${name}_morning_end`
 * - `${name}_afternoon_start`, `${name}_afternoon_end`
 *
 * をそれぞれ「時(hour)」部分と「分(minute)」部分に分解して、
 * - hour 部分は `*_shift_*_hour` 変数（文字列）に、
 * - minute 部分は各分 ref（{ name: "◯分", value: "◯" }）に格納する
 *
 * 最終的に以下のオブジェクトを返却:
 * ```
 * {
 *   `${name}_off`: 休業フラグ(boolean),
 *   `${name}_morning_start`: 午前開始時(時文字列),
 *   `${name}_morning_start_minute`: 午前開始分(ref),
 *   `${name}_morning_end`: 午前終了時(時文字列),
 *   `${name}_morning_end_minute`: 午前終了分(ref),
 *   `${name}_afternoon_start`: 午後開始時(時文字列),
 *   `${name}_afternoon_start_minute`: 午後開始分(ref),
 *   `${name}_afternoon_end`: 午後終了時(時文字列),
 *   `${name}_afternoon_end_minute`: 午後終了分(ref)
 * }
 * ```
 *
 * @returns {Object} フォーム初期値オブジェクト
 */
const formDataInit = computed(() => {
  // 午前開始時間の「時分」を抽出
  const rawMorningStart = get(props.data?.[`${props["name"]}_morning_start`]) ?? "8";
  const morning_shift_start_hour = parseInt(rawMorningStart, 10).toString();
  if (get(props.data?.[`${props["name"]}_morning_start`])?.length > 2) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_morning_start`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_morning_start`])?.split(":")[1].toString(),
    };
    set(morningStartMinute, temp);
  }

  // 午前終了時間の「時分」を抽出
  const rawMorningEnd = get(props.data?.[`${props["name"]}_morning_end`]) ?? "12";
  const morning_shift_end_hour = parseInt(rawMorningEnd, 10).toString();
  if (get(props.data?.[`${props["name"]}_morning_end`])?.length > 2) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_morning_end`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_morning_end`])?.split(":")[1].toString(),
    };
    set(morningEndMinute, temp);
  }

  // 午後開始時間の「時分」を抽出
  const rawAfternoonStart = get(props.data?.[`${props["name"]}_afternoon_start`]) ?? "13";
  const afternoon_shift_start_hour = parseInt(rawAfternoonStart, 10).toString();
  if (get(props.data?.[`${props["name"]}_afternoon_start`])?.length > 2) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_afternoon_start`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_afternoon_start`])?.split(":")[1].toString(),
    };
    set(afternoonStartMinute, temp);
  }

  // 午後終了時間の「時分」を抽出
  const rawAfternoonEnd = get(props.data?.[`${props["name"]}_afternoon_end`]) ?? "18";
  const afternoon_shift_end_hour = parseInt(rawAfternoonEnd, 10).toString();
  if (get(props.data?.[`${props["name"]}_afternoon_end`])?.length > 2) {
    let temp = {
      name: get(props.data?.[`${props["name"]}_afternoon_end`])?.split(":")[1].toString() + "分",
      value: get(props.data?.[`${props["name"]}_afternoon_end`])?.split(":")[1].toString(),
    };
    set(afternoonEndMinute, temp);
  }

  return {
    [`${props["name"]}_off`]: get(props.data?.[`${props["name"]}_off`]),
    [`${props["name"]}_morning_start`]: morning_shift_start_hour,
    [`${props["name"]}_morning_start_minute`]: morningStartMinute,
    [`${props["name"]}_morning_end`]: morning_shift_end_hour,
    [`${props["name"]}_morning_end_minute`]: morningEndMinute,
    [`${props["name"]}_afternoon_start`]: afternoon_shift_start_hour,
    [`${props["name"]}_afternoon_start_minute`]: afternoonStartMinute,
    [`${props["name"]}_afternoon_end`]: afternoon_shift_end_hour,
    [`${props["name"]}_afternoon_end_minute`]: afternoonEndMinute,
  };
});

/**
 * reactiveでフォームオブジェクトを生成
 * @type {import('vue').Reactive<{ [key: string]: any }>}
 */
const form = reactive(formDataInit.value);

/**
 * バリデーション用型定義
 * @typedef {Object} IFormRuleValidation
 * @property {number} startTimeMorning - 午前開始時刻 (hour + minute/60)
 * @property {number} endTimeMorning - 午前終了時刻
 * @property {number} startTimeAfterNoon - 午後開始時刻
 * @property {number} endTimeAfterNoon - 午後終了時刻
 */
const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator(value, rules, { validateOption: { suppressWarning: true } });

/**
 * 特定フィールドまたはフォーム全体を検証し、その結果を返す
 *
 * @async
 * @function
 * @param {string} [fieldName] - 検証対象フィールド名 (省略時は全体検証)
 * @returns {Promise<boolean>} 検証を通過したか
 */
const validate = async (fieldName?: string) => {
  // 1. 各時刻を数値化し、hour+minute/60 の形式でフィールド時間を作成
  const fieldTime = {
    startTimeMorning:
      parseInt(get(form[props["name"] + "_morning_start"])) + parseInt(get(morningStartMinute).value) / 60,
    endTimeMorning: parseInt(get(form[props["name"] + "_morning_end"])) + parseInt(get(morningEndMinute).value) / 60,
    startTimeAfterNoon:
      parseInt(get(form[props["name"] + "_afternoon_start"])) + parseInt(get(afternoonStartMinute).value) / 60,
    endTimeAfterNoon:
      parseInt(get(form[props["name"] + "_afternoon_end"])) + parseInt(get(afternoonEndMinute).value) / 60,
  } as IFormRuleValidation;

  // 2. 共通ルール関数からフォーム全体のバリデーションルールを取得
  const formRules = commonTimeWorkRules(fieldTime);

  // 3. 特定フィールド指定時は該当の value と rules だけを、未指定時は全体を対象に設定
  const [value, rules] = fieldName
    ? [{ [fieldName]: fieldTime[fieldName] }, { [fieldName]: formRules[fieldName] }]
    : [fieldTime, formRules];

  // 4. フォーム全体および個別フィールドの AsyncValidator インスタンスを初期化
  const { pass: formPass } = initValidation(form, formRules);
  const { execute } = initValidation(value, rules);

  // 5. バリデータを実行し、エラー情報を取得
  const { errorFields: fErrorFields, errors: fErrors } = await execute();

  // 6. 取得したエラー情報を reactive な ref に格納
  set(errorFields, get(fErrorFields));
  set(pass, get(formPass));
  set(errors, get(fErrors));

  // 7. 個々のフィールドエラーを順次チェックし、エラーメッセージがあれば通知
  const fieldNames = Object.keys(fieldTime);
  fieldNames.forEach(fieldName => {
    if (errorFields.value[fieldName]) {
      const errorMessage = (errorFields.value[fieldName][0] as ValidateError).message;
      if (errorMessage) {
        notityErrorMsg(toast, errorMessage);
      }
    }
  });

  // 8. バリデーション通過結果を返却
  return get(pass);
};

/**
 * バリデーション通過状況を保持するref
 * @type {import('vue').Ref<boolean>}
 */
const pass = ref(false);
/**
 * 各フィールドごとのエラー配列を保持するref
 * @type {import('vue').Ref<Record<string, ValidateError[]>>}
 */
const errorFields = ref<Record<string, ValidateError[]>>({});
/**
 * 全エラーを保持するref
 * @type {import('vue').Ref<ValidateError[]>}
 */
const errors = ref<ValidateError[]>([]);

/**
 * 時間選択用の時オプション配列
 * @type {{ name: string; value: string }[]}
 */
const hours = [...Array(24).keys()].map(hour => {
  return {
    name: hour + "時",
    value: hour.toString(),
  };
});

/**
 * 時間選択用の分オプション配列（5分刻み）
 * @type {{ name: string; value: string }[]}
 */
const minutes = [...range(0, 60, 5)].map(minute => {
  return {
    name: minute + "分",
    value: minute.toString(),
  };
});

/**
 * 指定フィールドを監視し、変更時に検証およびイベント発火を行う
 *
 * @function
 * @param {string} fieldName - 監視対象フィールドのサフィックス
 */
const watchField = (fieldName: string) => {
  watch(
    () => form[`${props["name"]}_${fieldName}`],
    async (newVal, oldVal) => {
      if (fieldName == "off") {
        set(pass, true);
        emits("validateFn", get(pass));
      } else {
        const checkValidate = await validate(fieldName);
        if (!checkValidate) {
          set(form, `${props["name"]}_${fieldName}`, oldVal);
        }
        emits("validateFn", get(pass));
      }
    }
  );
};

// フィールド監視の登録
watchField("off");
watchField("morning_start");
watchField("morning_end");
watchField("afternoon_start");
watchField("afternoon_end");
watchField("morning_start_minute");
watchField("morning_end_minute");
watchField("afternoon_start_minute");
watchField("afternoon_end_minute");

/**
 * formDataInit の変化時に reactive form を再初期化
 */
watch(formDataInit, newFormDataInit => {
  Object.assign(form, newFormDataInit);
});

/**
 * 現在のフォームデータを取得する
 *
 * @function
 * @returns {Record<string, any>} 現在の form オブジェクト
 */
const getDateData = () => {
  return get(form);
};

/**
 * コンポーネント外から呼び出せるメソッドを公開する
 * @method getDateData
 * @returns {Record<string, any>} 現在のフォームデータを返す
 */
expose({
  getDateData,
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(get)(_unref(dayOfWeek)[props["name"]])) + ": ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Dropdown, {
                  modelValue: form[props['name'] + '_morning_start'],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form[props['name'] + '_morning_start']) = $event)),
                  options: _unref(hours),
                  optionLabel: "name",
                  optionValue: "value",
                  placeholder: "",
                  class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.startTimeMorning }]),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (validate('startTimeMorning')))
                }, null, 8, ["modelValue", "options", "class"]),
                _hoisted_10,
                _createVNode(_component_Dropdown, {
                  modelValue: morningStartMinute.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((morningStartMinute).value = $event)),
                  options: _unref(minutes),
                  optionLabel: "name",
                  placeholder: "",
                  class: "shadow-none"
                }, null, 8, ["modelValue", "options"]),
                _hoisted_11,
                _createVNode(_component_Dropdown, {
                  modelValue: form[props['name'] + '_morning_end'],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form[props['name'] + '_morning_end']) = $event)),
                  options: _unref(hours),
                  optionLabel: "name",
                  optionValue: "value",
                  placeholder: "",
                  class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.endTimeMorning }]),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (validate('endTimeMorning')))
                }, null, 8, ["modelValue", "options", "class"]),
                _hoisted_12,
                _createVNode(_component_Dropdown, {
                  modelValue: morningEndMinute.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((morningEndMinute).value = $event)),
                  options: _unref(minutes),
                  optionLabel: "name",
                  placeholder: "",
                  class: "shadow-none"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Dropdown, {
                  modelValue: form[props['name'] + '_afternoon_start'],
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form[props['name'] + '_afternoon_start']) = $event)),
                  options: _unref(hours),
                  optionLabel: "name",
                  optionValue: "value",
                  placeholder: "",
                  class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.startTimeAfterNoon }]),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (validate('startTimeAfterNoon')))
                }, null, 8, ["modelValue", "options", "class"]),
                _hoisted_16,
                _createVNode(_component_Dropdown, {
                  modelValue: afternoonStartMinute.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((afternoonStartMinute).value = $event)),
                  options: _unref(minutes),
                  optionLabel: "name",
                  placeholder: "",
                  class: "shadow-none"
                }, null, 8, ["modelValue", "options"]),
                _hoisted_17,
                _createVNode(_component_Dropdown, {
                  modelValue: form[props['name'] + '_afternoon_end'],
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form[props['name'] + '_afternoon_end']) = $event)),
                  options: _unref(hours),
                  optionLabel: "name",
                  optionValue: "value",
                  placeholder: "",
                  class: _normalizeClass(["shadow-none", { 'p-invalid': errorFields.value?.endTimeAfterNoon }]),
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (validate('endTimeAfterNoon')))
                }, null, 8, ["modelValue", "options", "class"]),
                _hoisted_18,
                _createVNode(_component_Dropdown, {
                  modelValue: afternoonEndMinute.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((afternoonEndMinute).value = $event)),
                  options: _unref(minutes),
                  optionLabel: "name",
                  placeholder: "",
                  class: "shadow-none"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ], 512), [
          [_vShow, !form[props['name'] + '_off']]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col", { 'ml-4': !form[props['name'] + '_off'] }])
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_Checkbox, {
                modelValue: form[props['name'] + '_off'],
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form[props['name'] + '_off']) = $event)),
                class: "mr-2 checkbox",
                value: true,
                binary: true
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", {
                for: form[props['name'] + '_off']
              }, "休業日", 8, _hoisted_21)
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}
}

})